import { useState } from "react"
import type { PushAction } from "../data"
import ActionEditor from "./ActionEditor"
import ActionRow from "./ActionRow"
import Section from "./Section"

interface Props {
  actions: PushAction[]
  giftable: boolean
  onChange: (actions: PushAction[]) => void
}

// The actions decided for whatever the panel shows (a product or a batch),
// then, set apart under its own heading, a blank form always open for the
// next one.
export default function ActionsSection({ actions, giftable, onChange }: Props) {
  const [editingId, setEditingId] = useState<string | null>(null)
  const [blankKey, setBlankKey] = useState(0)

  const save = (saved: PushAction) => {
    const exists = actions.some((a) => a.id === saved.id)
    onChange(exists ? actions.map((a) => (a.id === saved.id ? saved : a)) : [...actions, saved])
    if (exists) setEditingId(null)
    else setBlankKey(blankKey + 1)
  }

  return (
    <Section title={`Actions · ${actions.length}`}>
      {actions.length > 0 ? (
        <div className="divide-y rounded-md border">
          {actions.map((action) =>
            editingId === action.id ? (
              <ActionEditor key={action.id} action={action} giftable={giftable} onSave={save} onCancel={() => setEditingId(null)} />
            ) : (
              <ActionRow key={action.id} action={action} onEdit={() => setEditingId(action.id)} onDelete={() => onChange(actions.filter((a) => a.id !== action.id))} />
            ),
          )}
        </div>
      ) : (
        <div className="rounded-md border px-4 py-3 text-sm">No actions yet.</div>
      )}

      {/* Always open, so the room can type the next action straight away.
          A new key after each save clears it. */}
      <h4 className="mb-2 mt-6 text-sm font-semibold">Add an action</h4>
      <div className="overflow-hidden rounded-md border">
        <ActionEditor key={`new-${blankKey}`} action={null} giftable={giftable} onSave={save} />
      </div>
    </Section>
  )
}
